'use strict';

/**
 * Type-guard - checks if a value is a string.
 *
 * @param x - The value to check.
 * @returns `true` if the value is a string, `false` otherwise.
 */ function isString(x) {
    return typeof x === 'string';
}

module.exports = isString;
